import { render } from "./Page4.vue?vue&type=template&id=28e2540d&scoped=true"
import script from "./Page4.vue?vue&type=script&lang=js"
export * from "./Page4.vue?vue&type=script&lang=js"

import "./Page4.vue?vue&type=style&index=0&id=28e2540d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28e2540d"]])

export default __exports__